/**
 * Catalog membership for map and public site (same list).
 * Fish/game stay in Sanity but are not in the product catalog.
 */

export function isWildHarvestSpeciesCategory(
  category: string | null | undefined,
): boolean {
  const key = String(category || "")
    .trim()
    .toLowerCase();
  return key === "fish" || key === "game";
}

/** Species that belong in the shared map + site catalog. */
export function isForagePrimarySpecies(species: {
  category?: string | null;
  slug?: string | null;
}): boolean {
  const slug = String(species.slug || "")
    .trim()
    .toLowerCase();
  // Legacy CMS rows may still be category "other" before taxonomy fixes run.
  if (slug === "alectoris-chukar") return false;
  return !isWildHarvestSpeciesCategory(species.category);
}

export function filterCatalogSpecies<T extends {
  category?: string | null;
  slug?: string | null;
}>(species: T[]): T[] {
  return species.filter(isForagePrimarySpecies);
}
